// extracted by mini-css-extract-plugin
export var copy = "TemplateTag-module--copy--0P2zB";
export var label = "TemplateTag-module--label--ZcolI";
export var tag = "TemplateTag-module--tag--JIBQE";